// COPIAR UNA PÓLIZA PARA CREAR OTRA A PARTIR DE ELLA.
//
// Lissette, 2026-10-15: "en la ficha de póliza colocar un botón para poder
// copiar esa póliza y crear una a partir de esa". Y ya existía la misma idea
// escrita a mano en "Marcar renovada → Crear póliza nueva" (deskte-full.jsx):
// ahora las dos salen de aquí.
//
// Se copia lo que DESCRIBE la póliza (tipo, compañía, plan, prima, costos,
// personas aseguradas, agente, forma de pago...) y se deja en blanco lo que
// IDENTIFICA a la vieja: su id, # de póliza, member IDs, # de aplicación, la
// etapa de renovación, la cancelación y las columnas propias. Una copia con el
// mismo # de póliza sería un duplicado, no una póliza nueva.
//
// Vive fuera de los componentes para poder probarse sin montar React.

const PROPIOS_DE_LA_VIEJA = [
  'id', 'clientId', 'clientName', 'policyNumber', 'memberId', 'memberIdsByPerson', 'applicationNumber',
  'renewalStage', 'renewalStageGuardada', 'renewalStageCycle', 'renewalStageAt', 'renewalStageBy',
  'renewalStageByName', 'renewalStageHistory', 'renewalNote', 'renewalKitSentAt', 'renewalKitSentCycle',
  'customData', 'cancellationDate', 'cancelReason', 'createdAt', 'updatedAt', 'deletedAt',
];

/**
 * La copia, lista para sembrar el formulario de "Agregar póliza".
 * Sale en estatus `pending` salvo que se pida otro: es una póliza que todavía
 * no está activa en la compañía.
 */
export function copiaDePoliza(p, cambios = {}) {
  const copia = { ...(p || {}) };
  for (const k of PROPIOS_DE_LA_VIEJA) delete copia[k];
  return { ...copia, status: 'pending', ...cambios };
}
